export class TradeGroup {
  idTradeGroup: number;
  name: string;
  telegram: string;
  timeframes: string;
  locked: boolean;

  constructor(
    idTradeGroup: number,
    name: string,
    telegram: string,
    timeframes: string,
    locked: boolean,
  ) {
    this.idTradeGroup = idTradeGroup;
    this.name = name;
    this.telegram = telegram;
    this.timeframes = timeframes;
    this.locked = locked;
  }

  static fromRaw(raw: any): TradeGroup {
    return new TradeGroup(
      raw.idTradeGroup,
      String(raw.name),
      String(raw.telegram),
      String(raw.timeframes),
      Boolean(raw.locked),
    );
  }

  clone(): TradeGroup {
    return new TradeGroup(
      this.idTradeGroup,
      this.name,
      this.telegram,
      this.timeframes,
      this.locked,
    );
  }

  toPayload(): any {
    const payload: any = {
      name: this.name,
      telegram: this.telegram,
      timeframes: this.timeframes,
    };
    if (this.idTradeGroup !== 0) {
      payload.idTradeGroup = this.idTradeGroup;
      payload.locked = this.locked;
    }
    return payload;
  }
}
